import { render } from "./BreadcrumbsList.vue?vue&type=template&id=3661db88"
import script from "./BreadcrumbsList.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__